import React from 'react'

export default ({ checked = false }) => (
  <svg width='32px' height='32px' viewBox='0 0 32 32' version='1.1' xmlns='http://www.w3.org/2000/svg'>
    <g stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g transform='translate(-701.000000, -540.000000)' fill='FF5027' stroke='#FFFFFF' strokeWidth='2'>
        <circle cx='717' cy='556' r='15' />
        {checked && <circle cx='717' cy='556' r='11' fill='#FFFFFF' />}
      </g>
    </g>
  </svg>
)



// WEBPACK FOOTER //
// ./src/components/Icons/RadioSvg.jsx